"use strict";

class PriceCalculator {
  static calculatePriceSummaryOrderr(orderr) {
    let priceSummary = {};
    priceSummary.priceWithVat = 0;
    priceSummary.priceWithoutVat = 0;
    priceSummary.vatSummary = {};
    priceSummary.vat = 0;
    priceSummary.priceBeforeDiscount = 0;
    priceSummary.priceWithoutVatBeforeDiscount = 0;

    if (orderr != null) {
      let oigs = orderr.orderrItemGroups.items;
      for (let i = 0; i < oigs.length; i++) {
        priceSummary.priceWithVat += oigs[i].price;
        priceSummary.priceWithoutVat += oigs[i].priceWithoutDph;
        priceSummary.priceBeforeDiscount += oigs[i].priceBeforeDiscount;
        priceSummary.priceWithoutVatBeforeDiscount +=
          oigs[i].priceBeforeDiscountWithoutDph;
        priceSummary.vat += oigs[i].dph;
        if (priceSummary.vatSummary["vat_" + oigs[i].dphPercent] == undefined) {
          priceSummary.vatSummary["vat_" + oigs[i].dphPercent] = 0;
        }
        priceSummary.vatSummary["vat_" + oigs[i].dphPercent] += oigs[i].dph;
      }
      return priceSummary;
    } else {
      return null;
    }
  }

  static calculatePriceOrderrItemGroup(orderrItemGroup, discountPercent) {
    console.log("calculatePriceOrderrItemGroup");

    console.log(orderrItemGroup);
    if (orderrItemGroup == null) {
      return -1;
    }

    // hlavni ridici produkt
    if (orderrItemGroup.product == null) {
      console.log("product na OIG je null");
      return -1;
    }

    // samotny vypocet ceny

    // jedna se o set, vypocitat z toho
    if (orderrItemGroup.set != null) {
      return PriceCalculator.findPrice(
        orderrItemGroup.set.priceTables,
        orderrItemGroup.priceListType,
        orderrItemGroup.length,
        orderrItemGroup.numberOfPersons,
        discountPercent
      );
    }
    // pouze samostatny produkt
    else {
      let priceObj = PriceCalculator.findPrice(
        orderrItemGroup.product.priceTables,
        orderrItemGroup.priceListType,
        orderrItemGroup.length,
        orderrItemGroup.numberOfPersons,
        discountPercent
      );

      // pronasobenni podle poctu kusu
      priceObj.priceWithVat =
        orderrItemGroup.itemsCount * priceObj.priceWithVat;
      priceObj.priceWithoutVat =
        orderrItemGroup.itemsCount * priceObj.priceWithoutVat;
      priceObj.vat = orderrItemGroup.itemsCount * priceObj.vat;

      return priceObj;
    }
  }

  static findPrice(
    priceTables,
    priceListType,
    length,
    numberOfPersons,
    discountPercent
  ) {
    if (priceTables == null || priceTables.length == 0) {
      console.log("priceTables je null");
      return -1;
    }

    if (priceListType == null) {
      console.log("priceListType je null");
      return -1;
    }

    if (length == null) {
      console.log("length je null");
      return -1;
    }

    let dicountCoeficient = (100 - discountPercent) / 100;

    for (let i = 0; i < priceTables.length; i++) {
      let priceTable = priceTables[i];
      if (
        priceTable.numberOfPersons == numberOfPersons &&
        priceTable.priceListType == priceListType
      ) {
        let priceObj = {};
        priceObj.vatPercent = priceTable.dphPercent;

        priceObj.priceWithVatBeforeDiscount =
          PriceCalculator.findPriceInPriceTable(priceTable, length);

        priceObj.priceWithVat =
          priceObj.priceWithVatBeforeDiscount * dicountCoeficient;

        priceObj.vat = PriceCalculator.calculateVat(
          priceObj.priceWithVat,
          priceObj.vatPercent
        );

        priceObj.vatBeforeDiscount = PriceCalculator.calculateVat(
          priceObj.priceWithVatBeforeDiscount,
          priceObj.vatPercent
        );

        priceObj.priceWithoutVat = priceObj.priceWithVat - priceObj.vat;

        priceObj.priceWithoutVatBeforeDiscount =
          priceObj.priceWithVatBeforeDiscount - priceObj.vatBeforeDiscount;

        return priceObj;
      }
    }
    return -1;
  }

  static calculateVat(priceWithVat, vatPercent) {
    return Math.round((priceWithVat * vatPercent) / (100 + vatPercent));
  }

  static findPriceInPriceTable(priceTable, length) {
    console.log("findPriceInPriceTable");
    console.log(priceTable);
    console.log(length);

    switch (length) {
      case 1:
        return priceTable.price1;

      case 2:
        if (priceTable.price2 == null) {
          return priceTable.price1 + priceTable.priceEveryOther;
        }
        return priceTable.price2;

      case 3:
        if (priceTable.price3 == null) {
          return priceTable.price1 + priceTable.priceEveryOther * 2;
        }
        return priceTable.price3;

      case 4:
        if (priceTable.price4 == null) {
          return priceTable.price1 + priceTable.priceEveryOther * 3;
        }
        return priceTable.price4;

      case 5:
        if (priceTable.price5 == null) {
          return priceTable.price1 + priceTable.priceEveryOther * 4;
        }
        return priceTable.price5;

      case 6:
        if (priceTable.price6 == null) {
          return priceTable.price1 + priceTable.priceEveryOther * 5;
        }
        return priceTable.price6;

      case 7:
        if (priceTable.price7 == null) {
          return priceTable.price1 + priceTable.priceEveryOther * 6;
        }
        return priceTable.price7;

      case 8:
        if (priceTable.price8 == null) {
          return priceTable.price1 + priceTable.priceEveryOther * 7;
        }
        return priceTable.price8;

      case 9:
        if (priceTable.price9 == null) {
          return priceTable.price1 + priceTable.priceEveryOther * 8;
        }
        return priceTable.price9;

      case 10:
        if (priceTable.price10 == null) {
          return priceTable.price1 + priceTable.priceEveryOther * 9;
        }
        return priceTable.price10;

      case 11:
        if (priceTable.price11 == null) {
          return priceTable.price1 + priceTable.priceEveryOther * 10;
        }
        return priceTable.price11;

      case 12:
        if (priceTable.price12 == null) {
          return priceTable.price1 + priceTable.priceEveryOther * 11;
        }
        return priceTable.price12;

      case 13:
        if (priceTable.price13 == null) {
          return priceTable.price1 + priceTable.priceEveryOther * 12;
        }
        return priceTable.price13;

      case 14:
        if (priceTable.price14 == null) {
          return priceTable.price1 + priceTable.priceEveryOther * 13;
        }
        return priceTable.price14;

      case 15:
        if (priceTable.price15 == null) {
          return priceTable.price1 + priceTable.priceEveryOther * 14;
        }
        return priceTable.price15;

      case 16:
        if (priceTable.price16 == null) {
          return priceTable.price1 + priceTable.priceEveryOther * 15;
        }
        return priceTable.price16;

      case 17:
        if (priceTable.price17 == null) {
          return priceTable.price1 + priceTable.priceEveryOther * 16;
        }
        return priceTable.price17;

      case 18:
        if (priceTable.price18 == null) {
          return priceTable.price1 + priceTable.priceEveryOther * 17;
        }
        return priceTable.price18;

      case 19:
        if (priceTable.price19 == null) {
          return priceTable.price1 + priceTable.priceEveryOther * 18;
        }
        return priceTable.price19;

      case 20:
        if (priceTable.price20 == null) {
          return priceTable.price1 + priceTable.priceEveryOther * 19;
        }
        return priceTable.price20;

      default:
        return -1;
    }
  }
}

module.exports = PriceCalculator;
